export const ONLY_NUMBERS = new RegExp('^[0-9]*$');
export const ALPHA_NUMERIC = new RegExp('^[a-zA-Z0-9]*$');
export const HEX_COLOUR_REGEX = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
export const UUID_INVALID_CHARACTERS = /[^a-zA-Z0-9-]/g;
export const EMAIL_REGEX =
  /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
export const NON_DIGITS = /\D/g;
export const VALID_URL =
  /(https?:\/\/)?((www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.(([a-z]{2,63}\.)+[a-z]{2,63}|[a-z]{2,63})(\b|\/))([-a-zA-Z0-9@:%_+.~#?&//=]*)/i;
